import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";
import "./Home.css";

export default function Home({ data }) {
  const nav = useNavigate();
  const go = (page) => nav(page === "home" ? "/" : `/${page}`);

  const r1 = useReveal(); const r2 = useReveal(); const r3 = useReveal();
  const r4 = useReveal(); const r5 = useReveal(); const r6 = useReveal();

  const marqueeItems = [...(data?.marquee || []), ...(data?.marquee || [])];

  return (
    <div className="home">

      {/* ── HERO ────────────────────────────────────── */}
      <section className="h-hero">
        <video className="h-hero-vid" autoPlay loop muted playsInline>
          <source src="/hero-video.mp4" type="video/mp4" />
        </video>
        <div className="h-hero-ov" />
        <div className="h-scroll-ind">
          <div className="h-scroll-line" />
          <span>Scroll</span>
        </div>
        <div className="h-hero-c">
          <div className="h-hero-left">
            <span className="h-hero-tag">{data?.hero?.tag}</span>
            <h1 className="h-hero-title">
              {data?.hero?.title?.map((line, i) => (
                <span key={i} className={line === data?.hero?.titleItalic ? "italic" : ""}>{line}</span>
              ))}
            </h1>
            <span className="h-year">Real Estate Advisory</span>
          </div>
          <div className="h-hero-right">
            <p className="h-hero-sub">{data?.hero?.subtitle}</p>
            <div className="h-hero-btns">
              {data?.hero?.cta?.map(b => (
                <button key={b.label} className={`btn ${b.variant}`} onClick={() => go(b.page)}>{b.label}</button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── MARQUEE ─────────────────────────────────── */}
      <div className="h-marquee">
        <div className="h-mq-track">
          {marqueeItems.map((item, i) => (
            <span key={i} className="h-mq-item">{item}<span className="h-mq-dot">◆</span></span>
          ))}
        </div>
      </div>

      {/* ── ABOUT SPLIT ─────────────────────────────── */}
      <div className="h-about" ref={r1}>
        <div className="h-about-img rv3">
          <img src={data?.about?.image} alt="Advisory" loading="lazy" />
        </div>
        <div className="h-about-txt rv2">
          <span className="h-eyebrow-crim">{data?.about?.tag}</span>
          <h2 className="h-about-h2">
            {data?.about?.h2?.map((line, i) => (
              <span key={i} className={line === data?.about?.italic || line.includes(data?.about?.italic) ? "italic" : ""}>
                {line}{i < (data?.about?.h2?.length - 1) ? <br /> : ""}
              </span>
            ))}
          </h2>
          <div className="h-gbar" />
          {data?.about?.body?.map((p, i) => <p key={i} className="h-about-p">{p}</p>)}
          <button className="btn btn-dk" onClick={() => go(data?.about?.cta?.page)}>{data?.about?.cta?.label}</button>
        </div>
      </div>

      {/* ── THREE PILLARS ───────────────────────────── */}
      <section className="h-pillars" ref={r2}>
        <div className="h-pillars-hd">
          <span className="h-eyebrow rv">{data?.pillars?.tag}</span>
          <h2 className="h-pillars-title rv">{data?.pillars?.h2}</h2>
        </div>
        <div className="h-pillars-grid">
          {data?.pillars?.items?.map(item => (
            <div className="h-pillar rv" key={item.num} data-num={item.num}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── STATS ───────────────────────────────────── */}
      <section className="h-stats" ref={r3}>
        <div className="h-stats-g">
          {data?.stats?.map((s, i) => (
            <div className="h-stat rv" key={i}>
              <div className="h-stat-v">{s.value}</div>
              <div className="h-stat-l">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── SERVICES FULLBLEED CTA ──────────────────── */}
      <section className="h-svc-cta" style={{ backgroundImage: `url(${data?.cta?.bg})` }}>
        <div className="h-svc-ov" />
        <div className="h-svc-c" ref={r4}>
          <span className="h-eyebrow rv">{data?.cta?.tag}</span>
          <h2 className="h-svc-h2 rv">{data?.cta?.h2}</h2>
          <p className="h-svc-p rv">{data?.cta?.body}</p>
          <button className="btn btn-r rv" onClick={() => go(data?.cta?.cta?.page)}>{data?.cta?.cta?.label}</button>
        </div>
      </section>

      {/* ── TESTIMONIAL ─────────────────────────────── */}
      <section className="h-testi" ref={r5}>
        <div className="h-testi-inner">
          <div className="h-testi-mark rv">"</div>
          <blockquote className="h-testi-q rv">"{data?.testimonial?.quote}"</blockquote>
          <cite className="h-testi-by rv">— {data?.testimonial?.author}</cite>
        </div>
      </section>

      {/* ── NEWSLETTER ──────────────────────────────── */}
      <section className="h-nl" ref={r6}>
        <span className="h-eyebrow rv">{data?.newsletter?.tag}</span>
        <h2 className="h-nl-h2 rv">{data?.newsletter?.h2}</h2>
        <NewsletterForm data={data?.newsletter} />
      </section>

    </div>
  );
}

function NewsletterForm({ data }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);

  const subscribe = async () => {
    if (!email) return;
    try {
      const r = await fetch("/api/newsletter", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const j = await r.json();
      setStatus(j.success ? "ok" : "err");
      if (j.success) setEmail("");
    } catch { setStatus("err"); }
  };

  return (
    <div className="h-nl-wrap rv">
      <div className="h-nl-form">
        <input type="email" placeholder={data?.placeholder} value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={e => e.key === "Enter" && subscribe()} />
        <button className="btn btn-r" onClick={subscribe}>{data?.cta}</button>
      </div>
      {status === "ok"  && <p className="h-nl-msg">✓ Thank you for subscribing.</p>}
      {status === "err" && <p className="h-nl-msg err">Something went wrong. Try again.</p>}
    </div>
  );
}
